var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:[
    'medal',
    { 'medal--active': _vm.active } ]},[_c('p',{staticClass:"medal__japanese"},[_vm._v(" "+_vm._s(_vm.product.japanese)+" ")]),_c('FlipPic',{staticClass:"medal__pic",attrs:{"flipped":_vm.flipped,"recto":_vm.product.coin,"verso":_vm.product.back}}),_c('p',{staticClass:"medal__name"},[_vm._v(" "+_vm._s(_vm.product.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }